// PageLayout.jsx
// Provides the shared page container used by each screen in the app.

/**
 * PageLayout
 * Wraps page content in a centered column with the standard gradient background.
 */
export default function PageLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="mx-auto w-full max-w-3xl px-4 py-6 sm:py-8">
        {children}
        <footer className="mt-12 text-center text-xs text-slate-500 sm:text-sm">
          LocalVoice is a nonpartisan educational project. We help residents learn about local advocacy and civic participation opportunities. We do not take positions on legislation, candidates, or political parties.
        </footer>
      </div>
    </div>
  );
}
